import { LayoutLogin } from 'hpscm/components/layout/Login'
import { IRouteData } from 'src/core/routes/types'

export const CustomRoutes: IRouteData[] = [
  {
    path: '/',
    element: <LayoutLogin />,
    access: 'Guest',
  },
]
